import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RequestAccessStepOneComponent } from './step-one/step-one.component';
import { RequestAccessStepTwoComponent } from './step-two/step-two.component';
import { RequestAccessConfirmationComponent } from './confirmation/confirmation.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'access',
		pathMatch: 'full'
	},
	{
		path: 'step-one',
		component: RequestAccessStepOneComponent
	},
	{
		// SSO flow: user is recognised by the IdP but has no Cohelion
		// account.  Skip email verification — go straight to the wizard.
		path: 'sso',
		component: RequestAccessStepTwoComponent,
		data: {'requireToken': false, 'ssoFlow': true}
	},
	{
		path: 'access',
		component: RequestAccessStepTwoComponent,
		data: { 'requireToken': false }
	},
	{
		path: 'verify/:token',
		component: RequestAccessStepTwoComponent,
		data: { 'requireToken': true }
	},
	{
		path: 'confirmation/:id',
		component: RequestAccessConfirmationComponent,
		data: { 'requireRequestId': true }
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class RequestAccessRoutingModule {
}
